import { createReducer, createAction } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { getOEMFeed } from '../../api-purecars/feed-builder';

const FEED_REQUEST = 'FEED_REQUEST';
const FEED_SUCCESS = 'FEED_SUCCESS';
const FEED_FAILED = 'FEED_FAILED';

export const feedRequest = createAction(FEED_REQUEST);
export const feedSuccess = createAction(FEED_SUCCESS);
export const feedFailed = createAction(FEED_FAILED);

const COLUMN_POINTS = {
  purchaseApr: 1,
  purchaseMonths: 1,
  purchaseDownPayment: 1,
  leaseMonthlyPayment: 1,
  leaseMonths: 1,
  leaseDownPayment: 1,
  lowestPrice: 1,
};
/**
 * setRowScore looks feed's row for given columns that would leed to a better display ad. The
 * more of these populated columns the higher the score.
 */
const setRowScore = (row) => {
  let score = 0;
  for (const field in COLUMN_POINTS) {
    if (Object.prototype.hasOwnProperty.call(COLUMN_POINTS, field)) {
      if (row[field]) {
        score += COLUMN_POINTS[field] || 0;
      }
    }
  }
  return Object.assign({ score }, row);
};

const overrideDestinationUrl = (row) =>
  Object.assign({}, row, { DestinationUrl: 'http://purecars.com' });

export const getFeedRowFromModelYear = (model, year, feed) => {
  if (!model || !year || !feed) {
    return undefined;
  }
  return feed
    .filter(row => (row.model === model && row.year === year))
    .sort((a, b) => a.score - b.score)
    .pop();
};

function* fetchFeed({ payload: makeId }) {
  const feedDescriptionId = '873b0f36-bfd6-473d-b1df-a9251f4e19d5'; // 'new' feed description
  try {
    const rawFeed = yield getOEMFeed({ makeId, feedDescriptionId });
    const feed = rawFeed
      .map(setRowScore)
      .map(overrideDestinationUrl)
      .map(row => ({ makeId, ...row }));
    yield put(feedSuccess({ makeId, feed }));
  } catch (err) {
    yield put(feedFailed(err));
  }
}

export function watchFeedRequest() {
  return takeEvery(FEED_REQUEST, fetchFeed);
}

export const getFeedsStore = (state) => {
  const { feeds = {} } = state;
  return feeds;
};

const handleFeedRequest = (state) => Object.assign({}, state, { loading: true });
const handleFeedSuccess = (state, { makeId, feed }) => {
  const makeIdFeedDict = Object.assign({}, state.makeIdFeedDict, { [makeId]: feed });
  return Object.assign({}, state, { loading: false, makeIdFeedDict });
};
const handleFeedFailed = (state, error) => Object.assign({}, state, { loading: false, error });

const initState = {
  makeIdFeedDict: {},
};

export default createReducer({
  [feedRequest]: handleFeedRequest,
  [feedSuccess]: handleFeedSuccess,
  [feedFailed]: handleFeedFailed,
}, initState);



// WEBPACK FOOTER //
// ./src/main/data/feeds.js